module.exports = "./images/dif.png?b6c322bcf61c203a055c232aa0a80091";


//////////////////
// WEBPACK FOOTER
// ./src/images/dif.png
// module id = 5
// module chunks = 0